import type { EntityTypeConfiguration } from '@/services/ConfigService';
import type { EntityActionConfig, UIConfiguration } from '@/types/Entity';

export const isUiConfigEntityPageDisabled = (uiConfig?: UIConfiguration | null): boolean =>
  uiConfig?.disableEntityPages === true || uiConfig?.hideFromNavigation === true;

export const isEntityTypePageDisabled = (config?: EntityTypeConfiguration | null): boolean =>
  isUiConfigEntityPageDisabled(config?.ui_configuration);

export const filterNavigableEntityTypes = (
  types: EntityTypeConfiguration[] | null | undefined,
): EntityTypeConfiguration[] =>
  Array.isArray(types) ? types.filter((type) => !isEntityTypePageDisabled(type)) : [];

/** Returns true when the given entity action is safe for viewer (read-only) users. */
export const isReadOnlyEntityAction = (action: EntityActionConfig): boolean =>
  action.readOnly === true;
